// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			//scrollDownAction(60, 'scroll'); //function change logo on scroll
		})
	};

	if(!document.querySelector('section.top-content')){
		document.getElementById('header').classList.add('no-top-content');
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//let scrollButtons = document.querySelectorAll('.sub-menu ul li a');

	// if(scrollButtons.length > 0){
	// 	scrollButtons.forEach((button)=>{
	// 		button.addEventListener('click', (e)=>{
	// 			e.preventDefault();
	// 			let data = button.getAttribute('href').split('#')[1];
	// 			let target = document.getElementById(data);
	// 			let headerHeight = document.querySelector('header').offsetHeight + 55;

	// 			window.scrollTo({
	// 				top: target.offsetTop - headerHeight,
	// 				behavior: 'smooth'
	// 			});
	// 		});
	// 	});
	// }

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.getElementById('scrollWrapper')){
		const spaceHolder = document.getElementById('scrollWrapper');
		const horizontal = document.getElementById('horizontalContainer');

		function calcDynamicHeight() {
			const horizontalWidth = horizontal.scrollWidth;
			const dynamicHeight = horizontalWidth - window.innerWidth + window.innerHeight;
			spaceHolder.style.height = `${dynamicHeight}px`;
		}

		window.addEventListener('load', calcDynamicHeight);
		window.addEventListener('resize', calcDynamicHeight);

		window.addEventListener('scroll', () => {
			const offsetTop = spaceHolder.offsetTop;
			const scrollTop = window.scrollY;
			const scrollInModule = scrollTop - offsetTop;
			
			const maxScrollVertical = spaceHolder.offsetHeight - window.innerHeight;
			const maxScrollHorizontal = horizontal.scrollWidth - window.innerWidth;
		
			if (scrollInModule >= 0 && scrollInModule <= maxScrollVertical) {
				const percentage = scrollInModule / maxScrollVertical;
				const moveX = percentage * maxScrollHorizontal;
				
				horizontal.style.transform = `translateX(-${moveX}px)`;
			}
		});
	}

	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('open');
				});
				itemHead.parentNode.classList.toggle('open');
			});
		});
	});

	if(document.querySelector('.accordion-posts')){
		let buttonsAccordion = document.querySelectorAll('.js-accordion-posts-title');
		let imagesAccordion = document.querySelectorAll('.accordion-posts__images img');
		let lastClickAccordionPosts = null;

		buttonsAccordion.forEach((button) => {
			button.addEventListener('click', (e) => {
				let dataEntry = button.dataset.post;
				button.parentNode.classList.add('open');
				if(lastClickAccordionPosts){
					lastClickAccordionPosts.parentNode.classList.remove('open');
				}
				lastClickAccordionPosts = button;
				if(document.querySelector('.accordion-posts__images')){
					imagesAccordion.forEach((image)=>{
						image.classList.toggle('active', image.dataset.image == dataEntry);
					})
				}
			});
		});

		buttonsAccordion[0].click();
	}

	if (window.innerWidth <= 650) {
			const menu_Items = document.querySelectorAll('#privary-navigation li:has(.submenu)')
		let prevMenuItem
		menu_Items.forEach((element) => {
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			// const newListItem = `
			// 	<li class="privary-navigation__item primary-nav-js">
			// 		<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
			// 	</li>`

			// Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}
			
			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

	if(document.getElementById('menu-mobile')){
		document.querySelector('.js-close-menu').addEventListener('click',()=>{
			document.getElementById('menu-mobile').classList.remove('show');
		});

		document.querySelector('.js-open-menu').addEventListener('click',()=>{
			document.getElementById('menu-mobile').classList.add('show');
		});
	}

	if(document.querySelector('.form-module__field.tel input[type="tel"]')){
		document.querySelectorAll('.form-module__field.tel input[type="tel"]').forEach((input)=>{
			input.addEventListener('input', (e) => {
				let valueTel = e.target.value;
				valueTel = valueTel.replace(/[^0-9+]/g, '');

				if (valueTel.lastIndexOf('+') > 0) {
					const initialPlus = valueTel.startsWith('+');
					valueTel = (initialPlus ? '+' : '') + valueTel.replace(/\+/g, '');
				}
				e.target.value = valueTel;
			});
		})
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 50){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}